module.exports = __webpack_public_path__ + "img/5a5c3aa212e01c4da88fb2610d8577cd.872a3bc6.png";